import { inject, type Ref } from "vue";
import { CustomerProfile } from "@lemmonhq/types";

export type AuthSession = CustomerProfile;

export interface AuthContextType {
  customer: Ref<AuthSession | null>;
  setCustomer: (user: AuthSession | null) => void;
  showAuthDialog: (email?: string) => void;
  refresh: () => Promise<void>;
}

const AuthContextKey = Symbol("AuthContext");

export { AuthContextKey };

export function useCustomer(): AuthContextType {
  const context = inject<AuthContextType>(AuthContextKey);
  if (!context) {
    throw new Error("useCustomer must be used within an AuthProvider");
  }
  return context;
}
